<script>
import MainLayout from '../layouts/mainLayout'
import showMap from '@/components/showMapWindowMask'
import dialog from '@/components/Dialog'
import mapDropPin from '../../assets/map_icon/map_drop_pin.png'

export default {
  components: {MainLayout, showMap, 'v-dialog': dialog},
  data: function () {
    return {
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      shiftReservation: {},
      time: {},
      startAddress: '',
      arriveAddress: '',
      flag: 0,
      title: '',
      isConnectReserve: false
    }
  },
  created () {
    let shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
    console.log("shiftDetail")
    console.log(shiftDetail)
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.shiftReservation = JSON.parse(sessionStorage.getItem('shiftReservation'))
    if(this.shiftReservation.groupStartShiftId != this.shiftReservation.groupArriveShiftId){
      this.isConnectReserve = true
    }
    this.flag = shiftDetail.shiftInfo.shiftMovementStatus

    // 接続便一覧を取得してステータスをチェック
    let parentShiftId = shiftDetail.shiftInfo.parentShiftId
    if(parentShiftId == '' || parentShiftId == null){
      parentShiftId = shiftDetail.shiftInfo.shiftId
    }
    this.$axios.get('shift/queryShiftInfoListByParentShiftId', {params: {parentShiftId: parentShiftId}}).then(response => {
      let shiftInfoList
      console.log("queryShiftInfoListByParentShiftId")
      console.log(response.data.shiftInfoList)
      shiftInfoList = response.data.shiftInfoList
      // 接続便の中にひとつでも業務終了があれば以降ステータスは更新しない
      if(this.flag != 3){
        for (let shiftInfoTemp of shiftInfoList) {
          // 接続便の状態チェック
          if(shiftInfoTemp.businessStatus == 2){
            console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務開始」です")
            this.flag = 2
          }else if(shiftInfoTemp.businessStatus == 3){
            console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務終了」です")
            this.flag = 3
            break;
          }
        }
      }
    })
    

    // if (this.shiftReservation.reserveType === 2) {
    //   this.shiftReservation.passengerCost = shiftDetail.shiftInfo.shiftCost * this.shiftReservation.passengerNumber
    // }
    if (this.flag === 1) {
      this.title = '乗客予約詳細'
    } else {
      this.title = '乗客詳細'
    }
    // 取上车自宅地址
    if (this.shiftReservation.startPlaceType === 1) {
      this.startAddress = '乗車場所:自宅'
      userInfo.forEach(item => {
        if (this.shiftReservation.passengerUid === item.uid) {
          this.shiftReservation.startPlaceLat = Number(item.homeLat.substring(0, 10))//
          this.shiftReservation.startPlaceLng = Number(item.homeLng.substring(0, 10))//
        }
      })
      // 取上车自宅地名称
    } else if (this.shiftReservation.startPlaceType === 3) {
      this.startAddress = '乗車場所:' + this.shiftReservation.startPlaceName
      // 取上车停留所信息
    } else {
      shiftDetail.shiftInfo.shiftPasspoints.forEach(element => {
        if (element.stationId === this.shiftReservation.startStationId) {
          this.shiftReservation.startPlaceName = element.stationName
          this.startAddress = '乗車場所:' + element.stationName
          this.shiftReservation.startPlaceLat = element.stationLat
          this.shiftReservation.startPlaceLng = element.stationLng
        }
      })
    }
    // 取下车自宅地址
    if (this.shiftReservation.arrivePlaceType === 1) {
      this.arriveAddress = '降車場所:自宅'
      userInfo.forEach(item => {
        if (this.shiftReservation.passengerUid === item.uid) {
          this.shiftReservation.arrivePlaceLat = Number(item.homeLat.substring(0, 10))
          this.shiftReservation.arrivePlaceLng = Number(item.homeLng.substring(0, 10))
        }
      })
      // 取下车自选地址
    } else if (this.shiftReservation.arrivePlaceType === 3) {
      this.arriveAddress = '降車場所:' + this.shiftReservation.arrivePlaceName
      // 取下车停留所地址
    } else {
      shiftDetail.shiftInfo.shiftPasspoints.forEach(element => {
        if (element.stationId === this.shiftReservation.arriveStationId) {
          this.shiftReservation.arrivePlaceName = element.stationName
          this.arriveAddress = '降車場所：' + element.stationName
          this.shiftReservation.arrivePlaceLat = element.stationLat
          this.shiftReservation.arrivePlaceLng = element.stationLng
        }
      })
    }
    this.time = this.shiftReservation.time
  },
  methods: {
    // 返回
    goback () {
      this.$router.go(-1)
      // this.$router.push({name: 'ReservationStatus'})
    },
    // 跳转预约
    jumpReservation () {
      this.$router.push({
        path: '/passengerReservation',
        name: 'passengerReservation'
      })
    },
    // 取消预约
    cancel () {
      if(this.isConnectReserve){
        this.dialogOption.text = `乗り継ぎがある便の予約のため、<br>乗り継ぎを行う便の予約も削除されますがよろしいですか？`
      }else{
        this.dialogOption.text = `${this.shiftReservation.lastName}${this.shiftReservation.firstName}さんの予約を取り消します</br>よろしいですか？`
      }
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        this.$axios.post('shift/reservationCancel', this.shiftReservation)
          .then(response => {
            this.goback()
          }).catch(error => {
            console.log(error)
            if (error.data.error === 'WBE2001') {
              this.showMessage(error.data.error_description)
            }else{
              this.showMessage('予期せぬエラーが発生しました。')
            }
          })
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
    },
    // マップ弹出场所地图
    map (homeLat, homeLng, homeAddress) {
      homeLat = parseFloat(homeLat)
      homeLng = parseFloat(homeLng)
      // 图标样式
      let vehiclePoint = {
        lat: homeLat,
        lng: homeLng,
        icon: mapDropPin
      }
      // 设置中心点
      this.$refs.showMapWindow.mapTitle = homeAddress
      this.$refs.showMapWindow.mapId = 'home'
      var centerPoint = {
        lat: homeLat,
        lng: homeLng
      }
      this.$refs.showMapWindow.centerPoint = centerPoint
      this.$refs.showMapWindow.markPosition = vehiclePoint
      this.$refs.showMapWindow.initiGoogleMap()
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    }
  }
}
</script>
<template>
<MainLayout>
    <div class="col-md-12 column"  style="width:100%;display:flex;flex-direction: column;flex:1;">
        <div class="row clearfix" style="flex:0 0 40px;position: relative;margin-top: 1.5%;">
           <div class="col-md-7 column headermiddle F3-M-27" style="position: absolute;width: 100%;">
             {{title}}
           </div>
            <div class="col-md-2 column headerleft F1-R-19">
              <input type="button" :value="$route.query.title"  @click="goback"/>
            </div>
        </div>
        <div class="row clearfix tablediv slider">
            <table class="table table-bordered window-table">
                <tbody>
                    <tr>
                        <td class="td-key td-key-Width F3-R-15 bgc8">
                            便名
                        </td>
                        <td colspan="3" class="td-value F3-M-18 bgc7">
                          {{shiftReservation.title}}
                        </td>
                    </tr>
                    <tr>
                        <td  class="td-key td-key-Width F3-R-15 bgc8">
                            便ID
                        </td>
                        <td colspan="3" class="td-value F3-M-18 bgc7">
                          {{shiftReservation.shiftId}}
                        </td>
                    </tr>
                     <tr>
                        <td  class="td-key td-key-Width F3-R-15 bgc8">
                            予約ID
                        </td>
                        <td colspan="3" class="td-value F3-M-18 bgc7">
                          {{shiftReservation.reserveId}}
                        </td>
                    </tr>
                    <tr>
                          <td class="td-key td-key-Width F3-R-15 bgc8">
                            フリガナ
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7">
                         {{shiftReservation.lastNameKana + shiftReservation.firstNameKana}}
                        </td>
                        <td class="td-key td-key-Width F3-R-15 bgc8">
                            ステータス
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7" v-if="shiftReservation.status==1">
                          確定
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7" v-if="shiftReservation.status==2">
                          キャンセル待ち
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7" v-if="shiftReservation.status==3">
                          予約取消
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7" v-if="shiftReservation.status==4">
                          予約失敗
                        </td>
                    </tr>
                    <tr>
                        <td class="td-key td-key-Width F3-R-15 bgc8">
                            乗客(代表者)
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7">
                          {{shiftReservation.lastName+shiftReservation.firstName}}
                        </td>
                        <td  class="td-key td-key-Width F3-R-15 bgc8">
                            予約受付方法
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7" v-if="shiftReservation.reserveType==1">
                          電話
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7" v-if="shiftReservation.reserveType==2">
                          アプリ
                        </td>
                    </tr>
                    <tr>
                        <td class="td-key td-key-Width F3-R-15 bgc8">
                            乗車人数
                        </td>
                          <td  class="td-value td-value-Width F3-M-18 bgc7">
                           {{shiftReservation.passengerNumber}}人
                        </td>
                        <td  class="td-key td-key-Width  F3-R-15 bgc8">
                              予約受付日時
                        </td>
                        <td  class="td-value td-value-Width F3-M-18 bgc7">
                          {{time.reserveTime}}
                        </td>
                    </tr>
                    <tr>
                        <td class="td-key td-key-Width F3-R-15 bgc8">
                            利用日
                        </td>
                        <td colspan="3" class="td-value F3-M-18 bgc7">
                            {{time.useTime}}
                        </td>
                    </tr>
                    <tr>
                          <td class="td-key td-key-Width F3-R-15 bgc8">
                              乗車場所
                        </td>
                        <td class="td-value td-value-Width">
                          <div class="row clearfix">
                                <div class="col-md-8 column F3-M-18 bgc7 overflow-fix" style="padding-left:20px;"  v-text="shiftReservation.startPlaceType==1?'自宅':shiftReservation.startPlaceName">
                                </div>
                                <div class="col-md-4 column">
                                    <a href="#modal-container-staySave"  data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                                    <button class="mapbtn F2-M-15 detailed-button" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" @click="map(shiftReservation.startPlaceLat,shiftReservation.startPlaceLng,startAddress)">
                                      マップ
                                  </button>
                                    </a>
                                  </div>
                            </div>
                        </td>
                        <td class="td-key td-key-Width  F3-R-15 bgc8">
                            乗車予定時間
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7">
                          {{time.startEstimateTime}}
                        </td>
                    </tr>
                    <tr>
                          <td class="td-key td-key-Width  F3-R-15 bgc8">
                              降車場所
                        </td>
                        <td class="td-value td-value-Width">
                            <div class="row clearfix">
                                <div class="col-md-8 column F3-M-18 bgc7 overflow-fix" style="padding-left:20px;"  v-text="shiftReservation.arrivePlaceType==1?'自宅':shiftReservation.arrivePlaceName">
                                </div>
                                <div class="col-md-4 column">
                                    <a href="#modal-container-staySave" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                                    <button class="mapbtn F2-M-15 detailed-button" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;" @click="map(shiftReservation.arrivePlaceLat, shiftReservation.arrivePlaceLng,arriveAddress)">
                                      マップ
                                  </button>
                                    </a>
                                  </div>
                            </div>
                        </td>
                        <td class="td-key td-key-Width  F3-R-15 bgc8">
                            到着予定時間
                        </td>
                        <td class="td-value td-value-Width F3-M-18 bgc7">
                          {{time.arriveEstimateTime}}
                        </td>
                    </tr>
                      <tr>
                        <td class="td-key td-key-Width  F3-R-15 bgc8">
                            利用料金
                        </td>
                        <td colspan="3" class="td-value F3-M-18 bgc7">
                          {{shiftReservation.passengerCost}}円
                        </td>
                    </tr>
                    <tr >
                        <td class="td-key  F3-R-15 bgc8" style="width:13%;text-align: center;line-height:90px">
                            備考
                        </td>
                        <td colspan="3" class="tooLong td-value F3-M-18 bgc7">
                          {{shiftReservation.note}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row clearfix" style="margin-bottom: 2%;">
                <div v-show="flag==1"  class="col-md-2 column delete-div" style="width:50%;padding-left: 19%;" >
                    <button   class="delete-btn F2-M-24" @click="jumpReservation()">編集</button>
                </div>
                <div v-show="flag==1||flag==2" class="col-md-4 column delete-div" :style="flag==2?'width:50%;padding-right: 19%;margin-left:34%':'width:50%;padding-right: 19%;'">
                    <button  class="delete-btn F2-M-24" @click="cancel()">予約を取り消す</button>
                </div>
            </div>
        </div>
        <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
        <showMap ref="showMapWindow"></showMap>
    </MainLayout>
</template>

<style scoped>

.headerleft {
  margin-left: 1.5%;
  padding-left:1%;
  width: 14.5%;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  height: 40px;
  width: 100%;
  text-align: left;
  text-indent: 35px;
}
.headermiddle {
  height: 40px;
  font-size: 24px;
}
.tablediv {
  flex: 1;
  margin:0px;
  margin-top:1.5%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: 10px;
  margin-top: 10px;
}
.window-table{
  margin-top: 2%;
  font-size: 14px;
  border: 1px solid rgb(148, 148, 148);
  width: 99.6%;
 }
.table-bordered>tbody>tr>td{
  border: 1px solid rgb(148, 148, 148);
  vertical-align: center;
}
.table>tbody>tr>td{
  padding: auto 0;
}
.table>tbody>tr>.td-value{
  padding-left: 30px;
}
.td-value{
  text-align: left;
}

.mapbtn{
  border-radius: 5px;
  border: 0px;
  float: right;
}
.delete-div{
  display :flex;
  flex-direction:row
}
.delete-btn{
  border-radius: 10px;
  font-size: 20px;
  background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
  background-color: #717171;
  border: 0;
  width:100%;
  margin-top: 5%;
  height: 50px;
}
.td-key-Width{
  width: 13%;
}
.td-value-Width {
  width: 40%;
}
.table>tbody>tr>td{
  vertical-align: inherit
}
.tooLong {
  word-wrap: break-word;
  word-break: break-all;
}
/* 滚动条*/
.scrollbar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.scrollbar::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
  box-shadow: none;
}
.scrollbar::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
  box-shadow: none;
}

</style>



// WEBPACK FOOTER //
// src/router/views/passengerReservationDetail.vue